import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import About from './components/About';
import Ranking from './components/Ranking';
import Media from './components/Media';
import Features from './components/Features';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Carousel from './components/Carousel';
import IndexSection from './components/IndexSection';
import Topics from './components/Topics';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <About />
        <Ranking />
        <Media />
        <Features />
        <Updates />
        <Cards />
        <Carousel />
        <IndexSection />
        <Topics />
        <Contact />
        <FAQ />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}